import { render, staticRenderFns } from "./PostListItem.vue?vue&type=template&id=00747eb3&scoped=true"
import script from "./PostListItem.vue?vue&type=script&lang=ts"
export * from "./PostListItem.vue?vue&type=script&lang=ts"
import style0 from "./PostListItem.vue?vue&type=style&index=0&id=00747eb3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00747eb3",
  null
  
)

export default component.exports